import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../../Components/ErrorContainer";
import { getFormData } from "../../../../helpers";
import SingleSearchSelect from "../../../Components/SingleSearchSelect";
import ModelContainer from "../../../Components/ModelContainer";

const NewApCreditNote = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const pageDetail = params?.location?.state;
  console.log(pageDetail, "pageDetailpageDetailpageDetailpageDetail");
  const newApCreditNotesOptions = useSelector(
    (state) => state?.financeReducer?.financeApCreditNotesOption
  );

  const editApCreditNotesData = useSelector(
    (state) => state?.financeReducer?.financeEditApCreditNotesData
  );

  const apCreditNotesOptions =
    pageDetail?.pageType === "edit"
      ? editApCreditNotesData
      : newApCreditNotesOptions;

  console.log(
    apCreditNotesOptions,
    "apCreditNotesOptions",
    editApCreditNotesData
  );
  useEffect(() => {
    if (pageDetail?.pageType === "edit")
      dispatch(actions?.getEditApCreditNotesData({ id: pageDetail?.id }));
    else dispatch(actions?.getApCreditNotesOption());
  }, []);

  const initialScheme = {
    finance_payee_id: "",
    credit_note_number: "",
    tax_charged: "",
    // mail_to_customer: "",
    memo: "",
    issuance_date: "",
    transaction_date: "",
    total_tax: "",
    total_price: "",

    ap_credit_note_item: [],
  };

  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [transactionDate, setTransactionDate] = useState(null);
  const [newAPState, setNewAPState] = useState(initialScheme);

  useEffect(() => {
    return () => {
      dispatch(
        actions.saveFinanceValues({
          financeApCreditNotesOption: null,
          financeEditApCreditNotesData: null,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (pageDetail?.pageType === "edit") {
      setNewAPState({
        ...editApCreditNotesData?.credit_note,
        tax_charged: editApCreditNotesData?.tax_charged,
      });
      setInvoiceDate(
        moment(editApCreditNotesData?.credit_note?.issuance_date).toDate()
      );
      setTransactionDate(
        moment(editApCreditNotesData?.credit_note?.transaction_date).toDate()
      );
      console.log(
        editApCreditNotesData?.financePayee?.find(
          (el) =>
            el?.value == editApCreditNotesData?.credit_note?.finance_payee_id
        ),
        "lllllllllllllllllllllll",
        editApCreditNotesData
      );
      setSelectedCustomer([
        editApCreditNotesData?.financePayee?.find(
          (el) =>
            el?.value == editApCreditNotesData?.credit_note?.finance_payee_id
        ) ?? [],
      ]);
      reset({
        ...editApCreditNotesData?.credit_note,
        tax_charged: editApCreditNotesData?.tax_charged,
      });
    } else {
      setValue("tax_charged", apCreditNotesOptions?.tax_charged);
    }
  }, [editApCreditNotesData, newApCreditNotesOptions]);

  useEffect(() => {
    setValue("ap_credit_note_item", newAPState?.ap_credit_note_item);
  }, [newAPState?.ap_credit_note_item]);

  const schema = yup.object().shape({
    finance_payee_id: yup.string().required(),
    credit_note_number: yup.string().required(),
    tax_charged: yup.string().required(),
    // mail_to_customer: yup.string().required(),
    memo: yup.string().required(),
    issuance_date: yup.string().required(),
    transaction_date: yup.string().required(),
    total_tax: yup.string().required(),
    total_price: yup.string().required(),

    ap_credit_note_item: yup
      .array()
      .of(
        yup.object().shape({
          account_id: yup.string().required(),
          item_description: yup.string().required(),
          price: yup.string().required(),
          quantity: yup.string().required(),
          sub_total: yup.string().required(),
          tax_type: yup.string().required(),
          tax: yup.string().required(),
          total: yup.string().required(),
          credit_account_id: yup.string().required(),
        })
      )
      .required(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initialScheme,
  });

  const submitData = (data) => {
    console.log(data, "oooooooooooooooo");
    dispatch(actions?.postApCreditNotesData({ data, history }));
  };
  const handleAddItem = () => {
    const newItem = {
      account_id: "",
      item_description: "",
      price: "",
      quantity: "",
      sub_total: 0,
      tax_type: "",
      tax: apCreditNotesOptions?.tax_charged,
      total: "",
      credit_account_id: "",
    };
    setNewAPState({
      ...newAPState,
      ap_credit_note_item: [...newAPState?.ap_credit_note_item, newItem],
    });
  };

  const updateAPinvoiceItem = (keyName, keyVal, rowIdx) => {
    const copyNewAPstate = JSON.parse(JSON.stringify(newAPState));
    const targetRow = copyNewAPstate?.ap_credit_note_item[rowIdx];
    targetRow[keyName] = keyVal;

    ///////////////////////////////////
    if (keyName === "quantity") {
      targetRow["sub_total"] = targetRow?.price * keyVal;
    }
    if (keyName === "price") {
      targetRow["sub_total"] = targetRow?.quantity * keyVal;
    }
    targetRow["total"] =
      targetRow?.sub_total + (targetRow?.sub_total * targetRow?.tax) / 100;

    // updating price
    copyNewAPstate["total_price"] = copyNewAPstate?.ap_credit_note_item?.reduce(
      (acc, curr) => acc + curr?.sub_total,
      0
    );
    copyNewAPstate["total_tax"] = copyNewAPstate?.ap_credit_note_item?.reduce(
      (acc, curr) => acc + (curr?.tax * curr?.sub_total) / 100,
      0
    );
    setValue("total_price", copyNewAPstate["total_price"]);
    setValue("total_tax", copyNewAPstate["total_tax"]);
    /////////////////////////////////////////////

    setNewAPState(copyNewAPstate);
  };

  function deleteApInvoiceItem(rowIdx) {
    const copyNewAPstate = JSON.parse(JSON.stringify(newAPState));
    copyNewAPstate?.ap_credit_note_item?.splice(rowIdx, 1);
    setNewAPState(copyNewAPstate);
  }
  function checkError(key, errors, idx) {
    return Object.keys(errors?.ap_credit_note_item?.[idx] ?? {})?.find(
      (el) => el === key
    ) === key
      ? true
      : false;
  }

  useEffect(() => {
    if (selectedCustomer.length > 0 && pageDetail?.pageType !== "edit") {
      dispatch(
        actions.getApCreditNotesTaxPercentage({
          id: selectedCustomer[0]?.value,
        })
      );
    }
  }, [selectedCustomer]);

  return (
    <UserInterface>
      <div
        // style={{ pointerEvents: pageDetail?.view === false ? "none" : "all" }}
        className="no-sidebar row"
        id="content"
      >
        {console.log("newState", newAPState)}
        {console.log("errors", errors)}
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <form onSubmit={handleSubmit(submitData)}>
            <div className="container px-0">
              <div className="shadowclass mt-4 mb-2">
                <div class="row mx-0">
                  <h4 class="event-alert"> New AP Invoice </h4>
                  <div class="col-md-6 px-0 px-sm-2">
                    <ul class="ingredient-info edit-shift">
                      <SingleSearchSelect
                        label={"Customer Name"}
                        formRegister={register}
                        formError={errors}
                        formKey="finance_payee_id"
                        selected={selectedCustomer}
                        setSelected={setSelectedCustomer}
                        options={apCreditNotesOptions?.financePayee}
                        setValue={setValue}
                      />
                      <Input
                        label={"Credit Note ID"}
                        formRegister={register}
                        value={newAPState?.credit_note_number}
                        onChange={(e) =>
                          setNewAPState({
                            ...newAPState,
                            credit_note_number: e.target.value,
                          })
                        }
                        formError={errors}
                        formKey={"credit_note_number"}
                      />
                    </ul>
                  </div>

                  <div class="col-md-6 px-0 px-sm-2">
                    <ul class="ingredient-info edit-shift">
                      <DateInput
                        label={"Issuance Date"}
                        formRegister={register}
                        formError={errors}
                        formKey="issuance_date"
                        setFormField={setValue}
                        dateVal={invoiceDate}
                        horizontal={true}
                        setDateVal={setInvoiceDate}
                      />
                      <DateInput
                        label={"Transaction Date"}
                        formRegister={register}
                        formError={errors}
                        formKey="transaction_date"
                        setFormField={setValue}
                        dateVal={transactionDate}
                        horizontal={true}
                        setDateVal={setTransactionDate}
                      />
                      <Input
                        label={"Memo"}
                        formRegister={register}
                        value={newAPState?.memo}
                        onChange={(e) =>
                          setNewAPState({
                            ...newAPState,
                            memo: e.target.value,
                          })
                        }
                        formError={errors}
                        formKey={"memo"}
                      />
                    </ul>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="checklist-table remove-space inventory_table">
                    <thead>
                      <tr>
                        <th> Item ID </th>
                        <th> Account Name </th>
                        <th> Item Description </th>
                        <th> Price </th>
                        <th> Quantity </th>
                        <th> Sub Total </th>
                        <th> Tax Type </th>
                        <th> Tax </th>
                        <th> Total </th>
                        <th> Credit/Clearing Account </th>
                      </tr>
                    </thead>
                    <tbody>
                      {newAPState?.ap_credit_note_item?.map((row, idx) => (
                        <tr className="InventoryRow">
                          <td>{idx + 1}</td>
                          <td>
                            <div class="select-div">
                              <div class="false">
                                <select
                                  value={
                                    newAPState?.ap_credit_note_item[idx]
                                      ?.account_id
                                  }
                                  onChange={(e) =>
                                    updateAPinvoiceItem(
                                      "account_id",
                                      e.target.value,
                                      idx
                                    )
                                  }
                                  class="required"
                                >
                                  <option value={""}>Select Account</option>
                                  {apCreditNotesOptions?.accounts?.map((el) => (
                                    <option value={el?.value}>
                                      {el?.label}
                                    </option>
                                  ))}
                                </select>
                                <div className="error">
                                  {checkError("account_id", errors, idx)
                                    ? "error"
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="false required">
                              <textarea
                                value={
                                  newAPState?.ap_credit_note_item[idx]
                                    ?.item_description
                                }
                                onChange={(e) =>
                                  updateAPinvoiceItem(
                                    "item_description",
                                    e.target.value,
                                    idx
                                  )
                                }
                                class="required small_textarea"
                              ></textarea>
                              <div className="error">
                                {checkError("item_description", errors, idx)
                                  ? "error"
                                  : ""}
                              </div>
                            </div>
                          </td>
                          <td>
                            {" "}
                            <input
                              value={
                                newAPState?.ap_credit_note_item[idx]?.price
                              }
                              onChange={(e) =>
                                updateAPinvoiceItem(
                                  "price",
                                  e.target.value,
                                  idx
                                )
                              }
                              class="required price currency invitemPrice"
                              type="text"
                            />
                            <div className="error">
                              {checkError("price", errors, idx) ? "error" : ""}
                            </div>
                          </td>
                          <td>
                            <input
                              value={
                                newAPState?.ap_credit_note_item[idx]?.quantity
                              }
                              onChange={(e) => {
                                updateAPinvoiceItem(
                                  "quantity",
                                  e.target.value,
                                  idx
                                );
                              }}
                              class="required quantity currency_ing invitemQty"
                              type="text"
                            />
                            <div className="error">
                              {checkError("quantity", errors, idx)
                                ? "error"
                                : ""}
                            </div>
                          </td>
                          <td>
                            {" "}
                            <span class="sub_total_val">
                              {newAPState?.ap_credit_note_item[idx]?.sub_total}
                            </span>{" "}
                          </td>
                          <td>
                            {" "}
                            <div className="select-div search-select-ms">
                              <select
                                value={
                                  newAPState?.ap_credit_note_item[idx]?.tax_type
                                }
                                onChange={(e) => {
                                  updateAPinvoiceItem(
                                    "tax_type",
                                    e.target.value,
                                    idx
                                  );
                                }}
                              >
                                <option value={""}>Select Tax Type</option>
                                {apCreditNotesOptions?.tax_type?.map((el) => (
                                  <option value={el?.value}>{el?.label}</option>
                                ))}
                              </select>
                              <div className="error">
                                {checkError("tax_type", errors, idx)
                                  ? "error"
                                  : ""}
                              </div>
                            </div>{" "}
                          </td>
                          <td>
                            {" "}
                            <input
                              value={newAPState?.ap_credit_note_item[idx]?.tax}
                              onChange={(e) =>
                                updateAPinvoiceItem("tax", e.target.value, idx)
                              }
                              class="tax_val number currency"
                              type="text"
                            />{" "}
                          </td>
                          <td className="total_val">
                            {" "}
                            {newAPState?.ap_credit_note_item[idx]?.total}
                          </td>
                          <td>
                            {" "}
                            <div className="select-div search-select-ms">
                              <select
                                value={
                                  newAPState?.ap_credit_note_item[idx]
                                    ?.credit_account_id
                                }
                                onChange={(e) => {
                                  updateAPinvoiceItem(
                                    "credit_account_id",
                                    e.target.value,
                                    idx
                                  );
                                }}
                              >
                                <option value={""}>Select Account</option>
                                {apCreditNotesOptions?.expense_account?.map(
                                  (el) => (
                                    <option value={el?.value}>
                                      {el?.label}
                                    </option>
                                  )
                                )}
                              </select>
                              <div className="error">
                                {checkError("credit_account_id", errors, idx)
                                  ? "error"
                                  : ""}
                              </div>
                            </div>{" "}
                          </td>
                          <td>
                            <a
                              onClick={() => deleteApInvoiceItem(idx)}
                              class="circle_icon red remove_single_item"
                              val="7581"
                            >
                              <i class="iconSprites cancel-icon"> </i>
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div class="my-3">
                  <button
                    onClick={handleAddItem}
                    class="btn green-btn-revert add-plus"
                    type="button"
                  >
                    <i class="i-icon"> </i> Add Item
                  </button>
                </div>

                <div class="total-price row mx-0">
                  <div class="attachment col-md-6 px-0">
                    <div class="file-button">
                      {/* <input type="file" name="data[ApCreditNote][attachment]" id="credit_note_file" style="display: none">
                                        <div class="input-group fileUpload claim-date">
                                            <a href="#_" id="upload_credit_note_file" class="btn bordered-btn file-button">Add Attachment</a>
                                            <span id="credit_note_file_name"></span>
                                        </div> */}

                      <div class="input-group fileUpload claim-date">
                        <input
                          type="file"
                          name="data[ApCreditNote][attachment]"
                          id="credit_note_file"
                          onChange={(e) => {
                            console.log(
                              e.target.files,
                              "kkkkkkkkkkkk",
                              getFormData({ attachment: e.target.files[0] })
                            );
                            document.getElementById(
                              "invoice_file_name"
                            ).innerText = e.target.files[0]?.name;

                            dispatch(
                              actions?.postCreditNotesAttachment(
                                getFormData({ attachment: e.target.files[0] })
                              )
                            );
                          }}
                        />
                        <a
                          href="#_"
                          id="upload_invoive_file"
                          class="btn bordered-btn file-button"
                        >
                          Add Attachment
                        </a>
                        <span id="invoice_file_name"></span>
                      </div>
                    </div>
                  </div>
                  <div class="paymentStatus col-md-6">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <b> Total Tax </b>
                          </td>
                          <td class="align-right">
                            <b>
                              <span id="total_tax">
                                ${newAPState?.total_tax}
                              </span>
                            </b>
                          </td>
                        </tr>
                        <tr class="grn-txt">
                          <td>
                            <b> Total </b>
                          </td>
                          <td class="align-right">
                            <strong>
                              <span id="grand_total">
                                {" "}
                                ${newAPState?.total_price}
                              </span>
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="btn-sec-row clearfix">
                <a
                  onClick={() => history.push("/order/ar-invoices")}
                  class="btn cancel mx-2"
                >
                  Cancel
                </a>
                <button class="btn green-btn-revert mx-0" type="submit">
                  Submit
                </button>
              </div>

              <div className="accordion" id="accordionPanelsStayOpenExample">
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0"> History </h4>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="row justify-content-between align-items-center">
                            <div className="col-md-4">
                              <div className="search-box mt-0">
                                <form>
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                                </form>
                              </div>
                            </div>
                          </div>

                          <div className="table-responsive">
                            <table className="checklist-table history-table">
                              <thead>
                                <tr>
                                  <th> Start </th>
                                  <th>End</th>
                                  <th>Field</th>
                                  <th>Value</th>
                                  <th>Replacement Value</th>
                                </tr>
                              </thead>
                              <tbody></tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </UserInterface>
  );
};
export default NewApCreditNote;
